import { Calendar, Image as ImageIcon, Sparkles, TrendingUp } from 'lucide-react';
import { LandingTemplate, type LandingData } from '../components/LandingTemplate';
import { LANDING_GUIDES } from '../lib/landingGuides';

const data: LandingData = {
  seo: {
    title: 'Programar pines en Pinterest desde el ordenador · Zettapost',
    description:
      'Programa pines en Pinterest con su tablero y su enlace desde el ordenador, junto al resto de tus redes. Guía paso a paso. Prueba 3 días gratis.',
    canonical: 'https://zettapost.com/programar-pinterest',
  },
  hero: {
    eyebrow: 'Programar Pinterest',
    headlinePre: 'Programa pines en Pinterest',
    headlineAccent: 'y multiplica tu tráfico.',
    subhead:
      'Sube tus pines, asígnalos a sus tableros y prográmalos en lote. La red social que más tráfico orgánico mueve, ahora con la productividad de un calendario serio.',
    bullets: [
      'Pines a tableros específicos',
      'IA para título y descripción',
      'Multi-cuenta y multi-tablero',
      '3 días gratis',
    ],
  },
  why: {
    eyebrow: '¿Por qué Zettapost para Pinterest?',
    title: 'El motor de tráfico que se merece un calendario serio.',
    subtitle:
      'Pensado para e-commerce, blogs, creadoras y marcas que viven del tráfico orgánico que les manda Pinterest.',
    items: [
      {
        Icon: Calendar,
        title: 'Programa pines en lote',
        description:
          'Sube varios pines de una vez, asígnalos a sus tableros y prográmalos a lo largo de días o semanas. Cero clics repetidos.',
      },
      {
        Icon: ImageIcon,
        title: 'Tablero exacto, link incluido',
        description:
          'Cada pin se publica en el tablero que tú elijas, con su link de destino. Perfecto para campañas estacionales y catálogos de producto.',
      },
      {
        Icon: Sparkles,
        title: 'IA para título y descripción',
        description:
          'Pinterest premia las descripciones largas con keywords. La IA te genera título y descripción optimizados para SEO de Pinterest sin esfuerzo.',
      },
      {
        Icon: TrendingUp,
        title: 'Mide qué pines tiran',
        description:
          'Impresiones, guardados, clics y outbound clicks de cada pin sincronizados desde Pinterest. Sabe qué pines te traen tráfico de verdad.',
      },
    ],
  },
  guide: LANDING_GUIDES.pinterest,
  faqs: [
    {
      q: '¿Necesito una cuenta Business de Pinterest?',
      a: 'Sí. La API oficial de Pinterest solo permite programar publicaciones desde cuentas Business (es gratis cambiar y conserva todos tus pines). El cambio se hace en 30 segundos desde los ajustes de Pinterest.',
    },
    {
      q: '¿Puedo asignar cada pin a un tablero distinto?',
      a: 'Sí. Al programar el pin eliges en qué tablero se publica. Puedes programar 10 pines en una sentada, cada uno a un tablero diferente y con su link de destino propio.',
    },
    {
      q: '¿Soporta Idea Pins (carrusel de Pinterest)?',
      a: 'De momento soportamos pines estáticos y pines de vídeo, que son los formatos que mejor convierten. Idea Pins (la apuesta de Pinterest por TikTok) está en evaluación según cómo evolucione la propia plataforma.',
    },
    {
      q: '¿Funciona con la API oficial?',
      a: 'Sí, conectamos vía la Pinterest API for Business. Eso significa que tus pines son tratados igual que si los subieras manualmente — sin penalización en distribución.',
    },
    {
      q: '¿Cuántas cuentas de Pinterest puedo conectar?',
      a: 'Depende del plan. Los planes para marcas y agencias permiten conectar varias cuentas Business y agruparlas por cliente con sus colores y marca propios.',
    },
    {
      q: '¿Puedo programar pines con link a mi tienda?',
      a: 'Sí. Cada pin lleva su URL de destino (tu producto, tu post de blog, tu landing). Es justo donde Pinterest convierte más que cualquier otra red social.',
    },
  ],
  finalCta: {
    title: 'Programa Pinterest',
    titleAccent: 'y deja que el tráfico llegue solo.',
    description: 'Crea tu cuenta y conecta Pinterest gratis durante 3 días.',
  },
  related: [
    { to: '/programar-instagram', label: 'Programar Instagram' },
    { to: '/programar-facebook', label: 'Programar Facebook' },
    { to: '/precios', label: 'Ver precios' },
    { to: '/blog', label: 'Blog' },
  ],
};

export function ProgramarPinterest() {
  return <LandingTemplate data={data} />;
}
